export default {
	getAlergenos(){
		return [
			'mallorca',
			'km0',
			'altramuces',
			'apio',
			'cacahuetes',
			'crustaceos',
			'dioxido_de_azure_y_sulfitos',
			'frutos_cascara',
			'gluten',
			'huevos',
			'lacteos',
			'moluscos',
			'mostaza',
			'pescado',
			'sesamo',
			'soja'
		]
	},

}